"use client";

import * as PopoverPrimitive from "@radix-ui/react-popover";
import * as React from "react";
import { cn } from "../lib/cn";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;

export const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(function PopoverContent({ className, align = "center", sideOffset = 6, ...props }, ref) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        data-aio-popup=""
        style={{ transformOrigin: "var(--radix-popover-content-transform-origin)" }}
        className={cn(
          "z-50 w-72 rounded-md border border-border bg-bg-elevated p-4 text-fg shadow-md outline-none",
          "data-[state=open]:animate-[aio-pop-in_180ms_var(--aio-pop-ease-out)_both]",
          "data-[state=closed]:animate-[aio-pop-out_140ms_var(--aio-pop-ease-in)_both]",
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
});
